export const SET_STATIC_LOOKUPS = 'SetStaticLookups';
export const SET_STATES = 'SetStates';
export const SET_EMPLOYEE_POSITIONS = 'SetEmployeePositions';
